import * as React from 'react'
import Link from 'next/link'
import { on, off } from '@arsenal/arsenal/modules/event'

import Button from 'Components/button'
import BrandSeriesCarSelector from 'Components/selector/brand-series-car-single'
import { sendTeaCommEvent } from 'lib/tea-analyze'

import { ICar, IAction } from '../series/store'
interface IProps {
  pkCars: ICar[]
  dispatch: React.Dispatch<IAction>
  className?: string
}
export default function PkList(props: IProps) {
  const { pkCars, dispatch, className } = props
  const [showSelector, setSelector] = React.useState(false)
  const carIds = React.useMemo(() => {
    return pkCars.map((item) => item.carId).join(',')
  }, [pkCars])
  const ref = React.useRef<HTMLElement>(null)
  React.useEffect(() => {
    function handleDocumentClick(e: Event) {
      dispatch({
        type: 'togglePk',
        payload: false,
      })
    }
    on(window, 'click', handleDocumentClick)
    return () => {
      off(window, 'click', handleDocumentClick)
    }
  }, [])
  return (
    <section
      ref={ref}
      onClick={(e) => {
        e.stopPropagation()
      }}
      className={className}
    >
      <h1>车型对比</h1>
      <ul className="list">
        {pkCars.map((item) => (
          <li key={item.carId}>
            {item.carName}
            <span
              onClick={() => {
                dispatch({
                  type: 'removeCar',
                  payload: item.carId,
                })
              }}
              className="icon-dislike-ic"
            />
          </li>
        ))}
      </ul>
      <div className="select">
        <span
          onClick={() => {
            setSelector(!showSelector)
          }}
        >
          选择车型
        </span>
        {showSelector && (
          <BrandSeriesCarSelector
            className="brand-series-car-selector"
            onChange={(car) => {
              dispatch({
                type: 'addCar',
                payload: car,
              })
              setSelector(false)
            }}
          />
        )}
      </div>
      <Link
        href={`/auto/params?carIds=${carIds}`}
        as={`/auto/params?carIds=${carIds}`}
      >
        <a target={'_blank'}>
          <Button
            disabled={!carIds}
            className="button"
            type="primary"
            onClick={() => {
              sendTeaCommEvent('click_start_compare_button', {
                car_style_id: carIds,
              })
            }}
          >
            开始对比
          </Button>
        </a>
      </Link>
      {pkCars && pkCars.length ? (
        <div
          className="clear"
          onClick={() => {
            dispatch({
              type: 'clearCars',
            })
          }}
        >
          <span
            className="icon-delete-ic"
            onClick={() => {
              sendTeaCommEvent('click_clear_selected_cars', {
                car_style_id: carIds,
              })
            }}
          />
          清空车款
        </div>
      ) : null}
      <style jsx>
        {`
          section {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            width: 280px;
            z-index: 10000;
            overflow-y: auto;
            background: #fff;
            box-shadow: -2px 0 8px 0 rgba(0, 0, 0, 0.2);
          }
          h1 {
            padding: 16px 0;
            line-height: 33px;
            border-bottom: 1px solid #999;
            text-align: center;
            font-size: 24px;
          }
          ul {
            padding: 7px 16px;
            margin-bottom: 13px;
          }
          li {
            padding: 12px 0;
            line-height: 20px;
            font-size: 14px;
            border-bottom: 1px dashed #e6e6e6;
          }
          li span {
            float: right;
          }
          section :global(.button) {
            display: block;
            margin: 20px auto;
            width: 180px;
            height: 36px;
            line-height: 36px;
          }
          .select {
            position: relative;
            width: 248px;
            margin: 0 auto;
            padding: 8px 12px;
            line-height: 20px;
            font-weight: 500;
            border-radius: 4px;
            border: 1px solid rgba(64, 101, 153, 0.1);
            cursor: pointer;
            user-select: none;
            background-color: #ffffff;
          }
          .select:focus {
            border-color: #406599;
          }
          .select span {
            display: block;
          }
          section :global(.brand-series-car-selector) {
            top: 41px;
            left: 0;
          }
          .clear {
            text-align: center;
            color: #1a1a1a;
            cursor: pointer;
          }
          .clear:hover {
            color: #406599;
          }
          .icon-dislike-ic {
            font-size: 18px;
            vertical-align: 0px;
          }
          .icon-delete-ic {
            display: inline-block;
            font-size: 20px;
            vertical-align: middle;
            margin-top: -3px;
          }
        `}
      </style>
    </section>
  )
}
